(function (window, undefined) {
  var global = window;
  "use strict";

  var kontur = global.SkbKontur || (global.SkbKontur = {}),
      toolbox = kontur.Toolbox = {},
      knownPluginVersions = ["2.100", "2.9.5", "2.9.4", "2.9.3", "2.9.2", "2.9.1", "2.9.0", "2.8.2", "2.8.1", "2.8.0", "2.7.1", "2.7.0", "2.6.0", "2.5.1", "2.5.0", "2.4.0", "2.3.0", "2.2.0", ""];
  toolbox.version = "2.9.5.23";

  function emptyFunction() {}

  function extend(target) {
    for (var i = 1, len = arguments.length; i < len; i++) {
      var source = arguments[i];

      for (var key in source) {
        target[key] = source[key];
      }
    }

    return target;
  }

  function implement(child, parent, methods) {
    function F() {}

    F.prototype = parent.prototype;
    var proto = new F();

    if (methods) {
      extend(proto, methods);
    }

    proto.constructor = child;
    child.prototype = proto;
    return child;
  }

  function construct(constructor, args) {
    function F() {
      return constructor.apply(this, args);
    }

    F.prototype = constructor.prototype;
    return new F();
  }

  var console;

  (function () {
    function format(message) {
      return "kt: " + message || "";
    }

    var browser = global.console;

    if (browser) {
      console = {
        info: function info(message) {
          try {
            browser.info(format(message));
          } catch (ex) {}
        },
        error: function error(message) {
          try {
            browser.error(format(message));
          } catch (ex) {}
        }
      };
    } else {
      console = {
        info: emptyFunction,
        error: emptyFunction
      };
    }
  })();

  var getProxy;
  var objectCache = {};

  (function () {
    var cachedProxy = null,
        availableProxies = [new NpApiProxy(), new ActiveXProxy()];

    getProxy = function getProxy(reset) {
      if (cachedProxy !== null && !reset) {
        return cachedProxy;
      }

      cachedProxy = null;
      objectCache = {};
      var proxy;

      for (var i = 0; i < availableProxies.length; i++) {
        proxy = availableProxies[i];

        if (proxy.init()) {
          break;
        }

        proxy = null;
      }

      if (!proxy) {
        proxy = new BaseProxy();
      } else {
        var info = proxy.getInfo();

        if (info && !info.denied && !info.disabled) {
          cachedProxy = proxy;
        }
      }

      console.info("api v" + toolbox.version);
      console.info(proxy.getInfoMessage());
      return proxy;
    };
  })();

  function createObject(name) {
    return getProxy().create(name);
  }

  function getSingletonObject(name) {
    var instance = objectCache[name];

    if (!instance) {
      instance = getProxy().create(name);
      objectCache[name] = instance;
    }

    return instance;
  }

  toolbox.getPluginInfo = function () {
    return getProxy().getInfo();
  };

  toolbox.refresh = function () {
    return getProxy(true).getInfo() !== null;
  }; // obsolete


  toolbox.reset = toolbox.refresh;

  function completeAsync(method, callback, error, result) {
    if (error) {
      error = new SystemError(method, getProxy().getException(error));
      fireError(error);
      callback(error);
    } else {
      callback(undefined, result);
    }
  }

  var errorCodeRegExp = /^\[([0-9]+)\]\s*/,
      winErrorCodeRegExp = /\(([0-9a-zA-Z]+):/;

  toolbox.onerror = function (error) {
    console.error(error);
  };

  function Error(method, message) {
    this.method = method;
    this.message = message;
  }

  Error.prototype.toString = function () {
    return this.message || "unknown error";
  };

  function NotInstallError(object, exception) {
    Error.call(this, object, "Component \"" + (object || '') + "\" is not installed");
    this.exception = exception;
  }

  function SecurityError(object) {
    Error.call(this, object, "Access to create \"" + (object || '') + "\" object is denied");
    this.accessDenied = true;
  }

  function ArgumentError(method, argument) {
    Error.call(this, method, "Invalid argument \"" + argument + "\" for method \"" + method + "\"");
    this.argument = argument;
  }

  function SystemError(method, exception) {
    var innerMessage,
        errorCode = -1,
        winErrorCode;

    if (exception) {
      innerMessage = exception.message || exception.toString();

      if (innerMessage) {
        var res = errorCodeRegExp.exec(innerMessage);

        if (res && res.length > 1) {
          errorCode = global.parseInt(res[1]);
          innerMessage = innerMessage.substring(res[0].length);
        }

        res = winErrorCodeRegExp.exec(innerMessage);

        if (res && res.length > 1) {
          winErrorCode = res[1];

          if (winErrorCode.indexOf("0x") !== 0) {
            winErrorCode = "0x" + parseInt(winErrorCode, 10).toString(16);
          }
        }
      }
    }

    Error.call(this, method, "Error at \"" + method + "\": " + (innerMessage || "unknown"));
    this.exception = exception;
    this.errorCode = errorCode;
    this.winErrorCode = winErrorCode;
  }

  toolbox.Error = Error;
  toolbox.SystemError = implement(SystemError, Error);
  toolbox.ArgumentError = implement(ArgumentError, Error);
  toolbox.NotInstallError = implement(NotInstallError, Error);
  toolbox.SecurityError = implement(SecurityError, Error);

  function fireError(error) {
    if (toolbox.onerror) {
      try {
        toolbox.onerror(error);
      } catch (ex) {}
    }
  }

  function raiseError(error) {
    fireError(error);
    throw error;
  }

  function throwError(method, message) {
    raiseError(new Error(method, message));
  }

  function throwArgument(method, argument) {
    raiseError(new ArgumentError(method, argument));
  }

  function throwSystem(method, ex) {
    if (!(ex instanceof Error)) {
      ex = new SystemError(method, getProxy().getException(ex));
    }

    raiseError(ex);
  }

  function throwNotInstall(object, ex) {
    raiseError(new NotInstallError(object, ex));
  }

  function throwSecurity(object) {
    raiseError(new SecurityError(object));
  }

  function isDefined(value) {
    return value !== null && value !== undefined;
  }

  function checkDefined(value, method, name) {
    if (!isDefined(value)) {
      throwArgument(method, name);
    }
  }

  function checkType(type, value, method, name) {
    if (typeof value !== type) {
      throwArgument(method, name);
    }
  }

  function checkString(value, method, name) {
    return checkType("string", value, method, name);
  }

  function checkNumber(value, method, name) {
    return checkType("number", value, method, name);
  }

  function checkBoolean(value, method, name) {
    return checkType("boolean", value, method, name);
  }

  function checkFunction(func, method, name) {
    if (typeof func !== "function") {
      throwArgument(method, name || "function");
    }
  }

  function BaseProxy() {
    this.create = function (name) {
      throwNotInstall(name);
    };

    this.init = function () {
      return false;
    };

    this.getInfo = function () {
      return null;
    };

    this.getException = function (ex) {
      return ex;
    };

    this.getDate = function (value) {
      return value;
    };

    this.getArray = function (value) {
      return value;
    };

    this.getInfoMessage = function () {
      var info = this.getInfo();

      if (!info) {
        return "plugin is not installed.";
      }

      var msg = "plugin v" + (info.version || "0.0") + " (" + info.name;

      if (info.disabled) {
        msg += ", disabled";
      }

      if (info.denied) {
        msg += ", denied";
      }

      msg += ")";
      return msg;
    };
  }

  function garbageCollect() {
    if ("CollectGarbage" in global) {
      try {
        global.CollectGarbage();
      } catch (e) {}
    }
  }

  toolbox.garbageCollect = garbageCollect;

  function ActiveXProxy() {
    BaseProxy.call(this);
    var axVersion,
        info = null;

    function create(name, version) {
      var axName = 'KonturToolbox2.' + name;

      if (version && version.length) {
        axName += "." + version;
      }

      return new global.ActiveXObject(axName);
    }

    function init() {
      info = null;
      var about;

      try {
        var tempAbout = create("About");
        var regVersion = tempAbout.RegVersion;

        if (regVersion) {
          axVersion = regVersion.substring(0, regVersion.lastIndexOf('.'));
          about = tempAbout.Version === regVersion ? tempAbout : create("About", axVersion);
        } else {
          throw "regVersion";
        }
      } catch (e) {
        for (var i = 0, len = knownPluginVersions.length; i < len; ++i) {
          try {
            about = create("About", knownPluginVersions[i]);
            axVersion = about.Version;
            axVersion = axVersion.substring(0, axVersion.lastIndexOf('.'));
            break;
          } catch (ex) {
            if (i + 1 === len) {
              throw ex;
            }
          }
        }
      }

      info = {
        name: 'ActiveX',
        version: about ? about.Version : null
      };

      if ("HasAccess" in about) {
        info.denied = !about.HasAccess();
      }

      if ("WinVersion" in about) {
        info.winVersion = about.WinVersion();
      }

      about = undefined;
    }

    this.init = function () {
      var result = false;

      if ("ActiveXObject" in global) {
        try {
          init();
          result = true;
        } catch (e) {}

        garbageCollect();
      }

      return result;
    };

    this.getInfo = function () {
      return info;
    };

    this.getDate = function (value) {
      return new Date(value);
    };

    this.getArray = function (value) {
      return new global.VBArray(value).toArray();
    };

    this.create = function (name) {
      try {
        return create(name, axVersion);
      } catch (ex) {
        throwNotInstall(name, ex);
      }
    };
  }

  function NpApiProxy() {
    BaseProxy.call(this);
    var document = global.document,
        mimeType = "application/x-kontur-toolbox",
        pluginName = "skbkontur.toolbox",
        objectStyle = "visibility:hidden;width:0px;height:0px;max-width:0;max-height:0" + ";margin:0;padding:0;border:0px none;position:absolute;",
        versionRegex = new RegExp("\\d\\.\\d\\.\\d(\\.\\d+)?"),
        plugin = null,
        inited = false,
        info = null;

    function getVersionFromFile(file) {
      if (file) {
        var matches = versionRegex.exec(file);

        if (matches) {
          return matches[0];
        }
      }

      return '';
    }

    function compareVersion(left, right) {
      if (left === right) {
        return 0;
      }

      if (!left || !left.length) {
        return -1;
      } // left <= right


      if (!right || !right.length) {
        return 1;
      } // left >= right


      var lNums = left.split("."),
          rNums = right.split("."),
          lCount = lNums.length,
          rCount = rNums.length;

      for (var i = 0, il = lCount < rCount ? lCount : rCount; i < il; ++i) {
        var diff = Number(lNums[i]) - Number(rNums[i]);

        if (0 !== diff) {
          return diff > 0 ? 1 : -1;
        }
      }

      return lCount === rCount ? 0 : lCount > rCount ? 1 : -1;
    }

    function getPluginVersion(npPlugin) {
      return npPlugin.version || getVersionFromFile(npPlugin.filename);
    }

    function getPluginInfo() {
      var plugins = global.navigator.plugins,
          bestPlugin = null,
          bestVersion = null;
      plugins.refresh(false);

      for (var i = 0, len = plugins.length; i < len; ++i) {
        var npPlugin = plugins[i],
            name = npPlugin.name;

        if (name && name.toLowerCase() === pluginName) {
          // important!
          var fileVersion = getPluginVersion(npPlugin);

          if (fileVersion && compareVersion(fileVersion, bestVersion) > 0) {
            bestVersion = fileVersion;
            bestPlugin = npPlugin;
          }
        }
      }

      return bestPlugin;
    }

    this.init = function () {
      inited = false;

      if (plugin && (!info || !info.disabled)) {
        document.body.removeChild(plugin);
        plugin = null;
        info = null;
      }

      var pluginInfo = getPluginInfo();

      if (!pluginInfo) {
        return false;
      }

      if (!plugin) {
        var tempPlugin = document.createElement("object");
        tempPlugin.setAttribute("type", mimeType);
        tempPlugin.setAttribute("style", objectStyle);
        document.body.appendChild(tempPlugin);
        var pluginMimeType = mimeType;
        var regVersion = tempPlugin.RegVersion;

        if (regVersion) {
          pluginMimeType = mimeType + '-' + regVersion.substring(0, regVersion.lastIndexOf('.'));
        } else {
          for (var i = 0, len = knownPluginVersions.length; i < len; ++i) {
            var name = mimeType + '-' + knownPluginVersions[i];

            if (global.navigator.mimeTypes[name]) {
              pluginMimeType = name;
              break;
            }
          }
        }

        if (regVersion && tempPlugin.Version === regVersion) {
          plugin = tempPlugin;
        } else {
          document.body.removeChild(tempPlugin);
        }

        if (!plugin) {
          plugin = document.createElement("object");
          plugin.setAttribute("type", pluginMimeType);
          plugin.setAttribute("style", objectStyle);
          document.body.appendChild(plugin);
        }
      }

      try {
        info = {
          name: 'NPAPI',
          version: plugin.Version,
          denied: !plugin.HasAccess()
        };

        if (plugin.WinVersion) {
          info.winVersion = plugin.WinVersion();
        }

        inited = true;
      } catch (ex) {
        info = {
          name: 'NPAPI',
          version: getPluginVersion(pluginInfo),
          disabled: true
        };
      }

      return !!info;
    };

    this.getInfo = function () {
      return info;
    };

    this.create = function (name) {
      if (inited) {
        var factoryMethod = "Create" + name;

        try {
          return plugin[factoryMethod]();
        } catch (ex) {
          throwSecurity(name);
        }
      }

      throwNotInstall(name);
    };

    this.getException = function (ex) {
      if (ex) {
        if (ex.message) {
          ex.message = decodeURIComponent(ex.message);
        } else {
          ex = decodeURIComponent(ex.toString());
        }
      }

      return ex;
    };
  }

  function isStream(value) {
    return value instanceof Stream;
  }

  function checkStream(value, method, name) {
    if (!(value instanceof Stream)) {
      throwArgument(method, name || "stream");
    }
  }

  function closeStream(stream) {
    if (stream && isStream(stream)) {
      try {
        stream.close();
      } catch (ex) {}
    }
  }

  function Stream() {}

  Stream.bufferSize = 65536;
  Stream.prototype = {
    constructor: Stream,
    readAll: function readAll() {
      return this.read(this.getSize());
    },
    readBase64: function readBase64(count) {
      var binary = this.read(count);

      try {
        var base64 = binary.toBase64();
        binary.close();
        return base64;
      } catch (ex) {
        binary.close();
        throw ex;
      }
    },
    readBase64Async: function readBase64Async(count, callback) {
      this.readAsync(count, function (err, binary) {
        if (err) {
          callback(err, null);
        } else {
          var base64 = binary.toBase64();
          binary.close();
          callback(null, base64);
        }
      });
    },
    writeBase64: function writeBase64(base64) {
      var binary = Binary.fromBase64(base64);

      try {
        this.write(binary);
        binary.close();
      } catch (ex) {
        binary.close();
        throw ex;
      }
    },
    writeBase64Async: function writeBase64Async(base64, callback) {
      var binary = Binary.fromBase64(base64);
      this.writeAsync(binary, function (err) {
        binary.close();
        callback(err);
      });
    },
    copyTo: function copyTo(dest, bufferSize) {
      var method = "Stream.copyTo";
      checkStream(dest, method, "dest");

      if (!bufferSize || bufferSize < 0) {
        bufferSize = Stream.bufferSize;
      }

      checkNumber(bufferSize);

      while (true) {
        var binary = this.read(bufferSize),
            size = binary.getSize();
        dest.write(binary);
        binary.close();

        if (size < bufferSize) {
          break;
        }
      }
    },
    copyToAsync: function copyToAsync(dest, callback, bufferSize) {
      var method = "Stream.copyToAsync",
          src = this;
      checkStream(dest, method, "dest");
      checkFunction(callback, method, "callback");

      if (!bufferSize || bufferSize < 0) {
        bufferSize = Stream.bufferSize;
      }

      checkNumber(bufferSize);

      function readNext() {
        src.readAsync(Stream.bufferSize, function (err, binary) {
          if (err) {
            callback(err);
          } else {
            var size = binary.getSize();
            dest.writeAsync(binary, function (err) {
              binary.close();

              if (err) {
                callback(err);
              } else {
                if (size < Stream.bufferSize) {
                  callback(null);
                } else {
                  readNext();
                }
              }
            });
          }
        });
      }

      readNext();
    }
  };

  function OperationToken(handle) {
    if (!handle) {
      handle = createObject("OperationToken");
    }

    this._handle = handle;
  }

  OperationToken.prototype = {
    constructor: OperationToken,
    isCanceled: function isCanceled() {
      try {
        return this._handle.IsCanceled();
      } catch (ex) {
        throwSystem("OperationToken.isCanceled", ex);
      }
    },
    setCanceled: function setCanceled() {
      try {
        return this._handle.SetCanceled();
      } catch (ex) {
        throwSystem("OperationToken.setCanceled", ex);
      }
    },
    progress: function progress() {
      try {
        return this._handle.Progress();
      } catch (ex) {
        throwSystem("OperationToken.progress", ex);
      }
    }
  };
  toolbox.OperationToken = OperationToken;
  var json;

  (function (undefined) {
    var escape = /["\\\x00-\x1f\x7f-\x9f]/g,
        meta = {
      '\b': '\\b',
      '\t': '\\t',
      '\n': '\\n',
      '\f': '\\f',
      '\r': '\\r',
      '"': '\\"',
      '\\': '\\\\'
    };

    function quoteString(string) {
      if (string.match(escape)) {
        return '"' + string.replace(escape, function (a) {
          if (a in meta) {
            return meta[a];
          }

          var code = a.charCodeAt();
          return "\\u00" + Math.floor(code / 16).toString(16) + (code % 16).toString(16);
        }) + '"';
      }

      return '"' + string + '"';
    }

    function padTen(value) {
      return value < 10 ? '0' + value : value;
    }

    function toIso8601Date(date) {
      var ms = date.getUTCMilliseconds();

      if (ms < 100) {
        ms = ms < 10 ? "00" + ms : "0" + ms;
      }

      return date.getUTCFullYear() + "-" + padTen(date.getUTCMonth() + 1) + "-" + padTen(date.getUTCDate()) + "T" + padTen(date.getUTCHours()) + ":" + padTen(date.getUTCMinutes()) + ":" + padTen(date.getUTCSeconds()) + "." + ms + "Z";
    }

    function parseJson(string) {
      if (!string || !string.length) {
        return undefined;
      }
      /*jshint evil:true */


      return new Function("return " + string)();
    }

    function stringify(object) {
      if (object === null) {
        return "null";
      }

      if (object === undefined) {
        return object;
      }

      var type = typeof object;

      if (type === 'number' || type === 'boolean') {
        return String(object);
      }

      if (type === 'string') {
        return quoteString(object);
      }

      if (object instanceof Date) {
        return '"' + toIso8601Date(object) + '"';
      }

      var pairs = [];

      if (object instanceof Array) {
        for (var i = 0; i < object.length; i++) {
          pairs.push(stringify(object[i]) || 'null');
        }

        return '[' + pairs.join(',') + ']';
      }

      if (type === 'object') {
        for (var prop in object) {
          if (object.hasOwnProperty(prop)) {
            var name;
            type = typeof prop;

            if (type === 'number') {
              name = '"' + prop + '"';
            } else if (type === 'string') {
              name = quoteString(prop);
            } else {
              continue;
            }

            var value = object[prop];
            type = typeof value;

            if (type !== 'function' && value !== undefined) {
              pairs.push(name + ':' + stringify(value));
            }
          }
        }

        return '{' + pairs.join(',') + '}';
      }
    }

    var nativeJson = global.JSON;
    json = {
      parse: nativeJson && nativeJson.parse ? nativeJson.parse : parseJson,
      stringify: nativeJson && nativeJson.stringify ? nativeJson.stringify : stringify,
      _parse: parseJson,
      _stringify: stringify
    };
  })();

  toolbox.JSON = json;
  var defaultCodePage = 65001,
      // CP_UTF8;
  utf16CodePage = 1200; // CP_UTF16;

  function Binary(handle) {
    if (!handle) {
      throwSystem('Invalid binary handle');
    }

    this._handle = handle;
  }

  function isBinary(value) {
    return value instanceof Binary;
  }

  function wrapBinary(handle) {
    return new Binary(handle);
  }

  function checkBinary(value, method, name) {
    if (!isBinary(value)) {
      throwArgument(method, name || "binary");
    }
  }

  function createActiveXmlObject() {
    var lastException,
        progIDs = ["Msxml2.DOMDocument.6.0", "MSXML2.DOMDocument.3.0", "MSXML2.DOMDocument", "MSXML.DOMDocument", "Microsoft.XMLDOM", "Msxml2.DOMDocument.4.0"];

    for (var i = 0, len = progIDs.length; i < len; i++) {
      try {
        return new global.ActiveXObject(progIDs[i]);
      } catch (ex) {
        lastException = ex;
      }
    }

    throw lastException;
  }

  function binaryToArray(binary, offset, count) {
    var array = new Array(count);

    try {
      for (var i = offset, k = 0; k < count; ++i, ++k) {
        array[k] = binary._handle.GetByte(i);
      }
    } catch (ex) {
      throwSystem("Binary.toArray", ex);
    }

    return array;
  }

  Binary.prototype = {
    constructor: Binary,
    chunkSize: 32768,
    getSize: function getSize() {
      try {
        return this._handle.Size;
      } catch (ex) {
        throwSystem("Binary.getSize", ex);
      }
    },
    getByte: function getByte(byteIndex) {
      var method = "Binary.getByte";
      checkNumber(byteIndex, method, "byteIndex");

      try {
        return this._handle.GetByte(byteIndex);
      } catch (ex) {
        throwSystem(method, ex);
      }
    },
    getCrc32: function getCrc32(initial) {
      var method = "Binary.getCrc32";

      if (isDefined(initial)) {
        checkNumber(initial, method, "initial");
      }

      try {
        var result;

        if (!isDefined(initial)) {
          result = this._handle.GetCrc32();
        } else {
          result = getBinaryService().GetCrc32(this._handle, initial);
        }

        return result >>> 0;
      } catch (ex) {
        throwSystem(method, ex);
      }
    },
    getCrc32Async: function getCrc32Async(crc, callback) {
      var method = "Binary.getCrc32Async";

      if (typeof crc === "function") {
        callback = crc;
        crc = 0;
      }

      checkNumber(crc, method, "crc");
      checkFunction(callback, method, "callback");

      try {
        getBinaryService().GetCrc32Async(this._handle, crc, function (crc32, error) {
          completeAsync(method, callback, error, crc32 >>> 0);
        });
      } catch (ex) {
        throwSystem(method, ex);
      }
    },
    getMd5: function getMd5() {
      var method = "Binary.getMd5";

      try {
        var handle = getBinaryService().GetMd5(this._handle);
        return wrapBinary(handle);
      } catch (ex) {
        throwSystem(method, ex);
      }
    },
    getMd5Async: function getMd5Async(callback) {
      var method = "Binary.getMd5Async";
      checkFunction(callback, method, "callback");

      try {
        getBinaryService().GetMd5Async(this._handle, function (md5, error) {
          var wrappedBinary = error ? undefined : wrapBinary(md5);
          completeAsync(method, callback, error, wrappedBinary);
        });
      } catch (ex) {
        throwSystem(method, ex);
      }
    },
    getSha256: function getSha256() {
      var method = "Binary.getSha256";

      try {
        var handle = getBinaryService().GetSHA256(this._handle);
        return wrapBinary(handle);
      } catch (ex) {
        throwSystem(method, ex);
      }
    },
    getSha256Async: function getSha256Async(callback) {
      var method = "Binary.getSha256Async";
      checkFunction(callback, method, "callback");

      try {
        getBinaryService().GetSHA256Async(this._handle, function (hash, error) {
          var wrappedBinary = error ? undefined : wrapBinary(hash);
          completeAsync(method, callback, error, wrappedBinary);
        });
      } catch (ex) {
        throwSystem(method, ex);
      }
    },
    equals: function equals(bin) {
      if (bin === null || bin === undefined) {
        return false;
      }

      if (bin instanceof Binary) {
        try {
          return this._handle.Equals(bin._handle);
        } catch (ex) {
          throwSystem("Binary.equals", ex);
        }
      }
    },
    toBase64: function toBase64() {
      try {
        return this._handle.ToBase64();
      } catch (ex) {
        throwSystem("Binary.toBase64", ex);
      }
    },
    toHexString: function toHexString() {
      try {
        return this._handle.ToHexString();
      } catch (ex) {
        throwSystem("Binary.toHexString", ex);
      }
    },
    decodeString: function decodeString(codePage) {
      if (codePage === utf16CodePage) {
        return this.decodeUnicodeString();
      }

      var method = "Binary.decodeString";

      if (codePage === undefined) {
        codePage = defaultCodePage;
      }

      checkNumber(codePage, method, "codePage");

      try {
        return this._handle.ToString(codePage);
      } catch (ex) {
        throwSystem(method, ex);
      }
    },
    decodeUnicodeString: function decodeUnicodeString() {
      try {
        return this._handle.ToUnicodeString();
      } catch (ex) {
        throwSystem("Binary.ToUnicodeString", ex);
      }
    },
    writeFile: function writeFile(fileName) {
      var method = "Binary.toFile";
      checkString(fileName, method, "fileName");

      try {
        this._handle.ToFile(fileName);
      } catch (ex) {
        throwSystem(method, ex);
      }
    },
    toXml: function toXml() {
      var xml,
          xmlString = this.toXmlString();

      try {
        if ("ActiveXObject" in global) {
          xml = createActiveXmlObject();
          xml.async = false;
          xml.loadXML(xmlString);
        } else {
          xml = new global.DOMParser().parseFromString(xmlString, "text/xml");
        }
      } catch (ex) {
        throwSystem("toXml", ex);
      }

      return xml;
    },
    toXmlString: function toXmlString() {
      try {
        return this._handle.ToXmlString();
      } catch (ex) {
        throwSystem("Binary.toXmlString");
      }
    },
    toArray: function toArray(offset, count) {
      var method = "Binary.toArray";

      if (offset === undefined || offset === null) {
        offset = 0;
      } else {
        checkNumber(offset, method, "offset");
      }

      if (count === undefined || count === null) {
        count = this.getSize();
      } else {
        checkNumber(count, method, "count");
      }

      try {
        if (count > this.chunkSize) {
          var array = [];
          var chunks = Math.floor(count / this.chunkSize) + (count % this.chunkSize ? 1 : 0);

          while (chunks > 0) {
            array.push.apply(array, getProxy().getArray(this._handle.ToArray(offset, this.chunkSize)));
            offset += this.chunkSize;
            --chunks;
          }

          return array;
        }

        return getProxy().getArray(this._handle.ToArray(offset, count));
      } catch (ex) {
        return binaryToArray(this, offset, count);
      }
    },
    close: function close() {
      try {
        this._handle.Reset();
      } catch (ex) {
        throwSystem("Binary.reset");
      }
    },

    /* obsolete */
    reset: function reset() {
      this.close();
    }
  };
  toolbox.Binary = Binary; // Binary factory methods

  function getBinaryService() {
    return getSingletonObject("BinaryObjectService");
  }

  Binary.empty = function () {
    var handle = createObject("BinaryObject");
    return new Binary(handle);
  };

  Binary.createStream = function () {
    var method = "Binary.createStream";

    try {
      var handle = getBinaryService().CreateStream();
      return new BinaryStream(handle);
    } catch (ex) {
      throwSystem(method, ex);
    }
  };

  Binary.fromBase64 = function (base64String) {
    var method = "Binary.fromBase64";
    checkString(base64String, method, "base64String");

    try {
      var handle = getBinaryService().BinaryObjectFromBase64(base64String);
      return wrapBinary(handle);
    } catch (ex) {
      throwSystem(method, ex);
    }
  };

  Binary.fromHex = function (hexString) {
    var method = "Binary.fromHex";
    checkString(hexString, method, "hexString");

    try {
      var handle = getBinaryService().BinaryObjectFromHex(hexString);
      return wrapBinary(handle);
    } catch (ex) {
      throwSystem(method, ex);
    }
  };

  Binary.encodeString = function (string, codePage) {
    if (codePage === utf16CodePage) {
      return Binary.encodeUnicodeString(string);
    }

    var method = "Binary.encodeString";
    checkString(string, method, "string");

    if (codePage === undefined) {
      codePage = defaultCodePage;
    }

    checkNumber(codePage, method, "codePage");

    try {
      var handle = getBinaryService().BinaryObjectFromString(string, codePage);
      return wrapBinary(handle);
    } catch (ex) {
      throwSystem(method, ex);
    }
  };

  Binary.encodeUnicodeString = function (string) {
    var method = "Binary.encodeUnicodeString";
    checkString(string, method, "string");

    try {
      var handle = getBinaryService().BinaryObjectFromUnicodeString(string);
      return wrapBinary(handle);
    } catch (ex) {
      throwSystem(method, ex);
    }
  };

  Binary.readFile = function (fileName) {
    var method = "Binary.readFile";
    checkString(fileName, method, "fileName");

    try {
      var handle = getBinaryService().BinaryObjectFromFile(fileName);
      return wrapBinary(handle);
    } catch (ex) {
      throwSystem(method, ex);
    }
  };

  function BinaryStream(handle) {
    if (!handle) {
      throw "Required file handle";
    }

    this._handle = handle;
  }

  function isBinaryStream(value) {
    return value instanceof BinaryStream;
  }

  implement(BinaryStream, Stream, {
    getPosition: function getPosition() {
      try {
        return this._handle.Position;
      } catch (ex) {
        throwSystem("BinaryStream.getPosition", ex);
      }
    },
    getSize: function getSize() {
      try {
        return this._handle.Size;
      } catch (ex) {
        throwSystem("BinaryStream.getSize", ex);
      }
    },
    close: function close() {
      try {
        this._handle.Close();
      } catch (ex) {
        throwSystem("BinaryStream.close", ex);
      }
    },
    resize: function resize(size) {
      var method = "BinaryStream.resize";
      checkNumber(size, method, "size");

      try {
        this._handle.Resize(size);
      } catch (ex) {
        throwSystem(method, ex);
      }
    },
    seek: function seek(position, location) {
      var method = "BinaryStream.seek";
      checkNumber(position, method, "position");

      if (location === undefined || location === null) {
        location = 0;
      } else {
        checkNumber(location, method, "location");
      }

      try {
        return this._handle.Seek(position, location);
      } catch (ex) {
        throwSystem(method, ex);
      }
    },
    read: function read(count) {
      var method = "BinaryStream.read";
      checkNumber(count, method, "count");

      try {
        return wrapBinary(this._handle.Read(count));
      } catch (ex) {
        throwSystem(method, ex);
      }
    },
    write: function write(binary, offset, count) {
      var method = "BinaryStream.write";
      checkBinary(binary, method);

      if (offset === undefined || offset === null) {
        offset = 0;
      } else {
        checkNumber(offset, method, "offset");
      }

      if (count === undefined || count === null) {
        count = binary.getSize();
      } else {
        checkNumber(count, method, "count");
      }

      try {
        this._handle.Write(binary._handle, offset, count);
      } catch (ex) {
        throwSystem(method, ex);
      }
    },
    writeAsync: function writeAsync(binary, offset, count, callback) {
      var method = "BinaryStream.writeAsync";
      checkBinary(binary, method);

      if (typeof offset === "function") {
        callback = offset;
        offset = 0;
        count = binary.getSize();
      } else {
        checkNumber(offset, method, "offset");
        checkNumber(count, method, "count");
        checkFunction(callback, method, "callback");
      }

      try {
        this._handle.WriteAsync(binary._handle, offset, count, function (handle, error) {
          completeAsync(method, callback, error);
        });
      } catch (ex) {
        throwSystem(method, ex);
      }
    },
    readAsync: function readAsync(count, callback) {
      var method = "BinaryStream.readAsync";
      checkNumber(count, method, "count");
      checkFunction(callback, method, "callback");

      try {
        this._handle.ReadAsync(count, function (handle, error) {
          var wrappedBinary = error ? undefined : wrapBinary(handle);
          completeAsync(method, callback, error, wrappedBinary);
        });
      } catch (ex) {
        throwSystem(method, ex);
      }
    },
    writeToAsync: function writeToAsync(position, binary, offset, count, callback) {
      var method = "BinaryStream.writeToAsync";
      checkNumber(position, method, "position");
      checkBinary(binary, method);

      if (typeof offset === "function") {
        callback = offset;
        offset = 0;
        count = binary.getSize();
      } else {
        checkNumber(offset, method, "offset");
        checkNumber(count, method, "count");
        checkFunction(callback, method, "callback");
      }

      try {
        this._handle.SeekAndWriteAsync(position, binary._handle, offset, count, function (handle, error) {
          completeAsync(method, callback, error);
        });
      } catch (ex) {
        throwSystem(method, ex);
      }
    },
    readFromAsync: function readFromAsync(position, count, callback) {
      var method = "BinaryStream.readFromAsync";
      checkNumber(position, method, "position");
      checkNumber(count, method, "count");
      checkFunction(callback, method, "callback");

      try {
        this._handle.SeekAndReadAsync(position, count, function (handle, error) {
          var wrappedBinary = error ? undefined : wrapBinary(handle);
          completeAsync(method, callback, error, wrappedBinary);
        });
      } catch (ex) {
        throwSystem(method, ex);
      }
    }
  });

  function ZipArchive(handle, stream) {
    if (handle === null || handle === undefined) {
      throw "Required zip archive handle";
    }

    if (stream === null || stream === undefined) {
      throw "Required zip archive stream";
    }

    this._handle = handle;
    this._stream = stream;
  }

  function wrapZipArchive(handle, stream) {
    return new ZipArchive(handle, stream);
  }

  ZipArchive.prototype = {
    constructor: ZipArchive,
    getEntries: function getEntries() {
      var entries;

      try {
        entries = this._handle.GetEntries();
      } catch (ex) {
        throwSystem("ZipArchive.getEntries", ex);
      }

      return json.parse(entries);
    },
    addEntry: function addEntry(name, input, callback) {
      var method = "ZipArchive.addEntry";
      checkString(name, method, "name");
      checkStream(input, method, "input");
      checkFunction(callback, method, "callback");

      try {
        this._handle.AddEntry(name, input._handle, function (handle, error) {
          completeAsync(method, callback, error, null);
        }, null);
      } catch (ex) {
        throwSystem(method, ex);
      }
    },
    getEntryStream: function getEntryStream(entry, output, callback) {
      var method = "ZipArchive.getEntryStream";

      if (typeof entry !== "number" && typeof entry !== "string") {
        throwArgument(method, "entry");
      }

      if (arguments.length > 2) {
        checkStream(output, method, "output");
      } else {
        callback = output;
        output = File.createTemp();
      }

      checkFunction(callback, method, "callback");

      try {
        if (typeof entry === "number") {
          this._handle.GetEntryByIndex(entry, output._handle, function (handle, error) {
            completeAsync(method, callback, error, output);
          }, null);
        } else {
          this._handle.GetEntryByName(entry, output._handle, function (handle, error) {
            completeAsync(method, callback, error, output);
          }, null);
        }
      } catch (ex) {
        throwSystem(method, ex);
      }
    },
    extract: function extract(entry, path, callback) {
      var method = "ZipArchive.extract";

      if (arguments.length > 2) {
        if (typeof entry !== "number" && typeof entry !== "string") {
          throwArgument(method, "entry");
        }
      } else {
        callback = path;
        path = entry;
        entry = "";
      }

      checkString(path, method, "path");
      checkFunction(callback, method, "callback");

      try {
        if (typeof entry === "number") {
          this._handle.ExtractByIndex(entry, path, function (handle, error) {
            completeAsync(method, callback, error, null);
          }, null);
        } else {
          this._handle.ExtractByName(entry, path, function (handle, error) {
            completeAsync(method, callback, error, null);
          }, null);
        }
      } catch (ex) {
        throwSystem(method, ex);
      }
    },
    close: function close() {
      try {
        this._handle.Close();

        this._stream.close();

        this._stream = null;
      } catch (ex) {
        throwSystem("ZipArchive.close", ex);
      }
    },
    getStream: function getStream() {
      try {
        this._handle.Close();

        this._stream.seek(0);

        var stream = this._stream;
        this._stream = null;
        return stream;
      } catch (ex) {
        throwSystem("ZipArchive.getStream", ex);
      }
    }
  };

  function getCompressionService() {
    return getSingletonObject("CompressionService");
  }

  toolbox.GZip = {
    pack: function pack(binary) {
      var method = "GZip.pack";
      checkBinary(binary, method);

      try {
        return wrapBinary(getCompressionService().GZip(binary._handle));
      } catch (ex) {
        throwSystem(method, ex);
      }
    },
    unpack: function unpack(binary) {
      var method = "GZip.unpack";
      checkBinary(binary, method);

      try {
        return wrapBinary(getCompressionService().GUnzip(binary._handle));
      } catch (ex) {
        throwSystem(method, ex);
      }
    }
  };
  toolbox.Zip = {
    pack: function pack(binary) {
      var method = "Zip.pack";
      checkBinary(binary, method);

      try {
        return wrapBinary(getCompressionService().PKZip(binary._handle));
      } catch (ex) {
        throwSystem(method, ex);
      }
    },
    unpack: function unpack(binary, fileIndex) {
      var method = "Zip.unpack";
      checkBinary(binary, method);

      if (fileIndex !== undefined && typeof fileIndex !== "number") {
        throwArgument(method, "fileIndex");
      }

      try {
        var handle;
        var service = getCompressionService();

        if (fileIndex !== undefined) {
          handle = service.PKUnzipN(binary._handle, fileIndex);
        } else {
          handle = service.PKUnzip(binary._handle);
        }

        return wrapBinary(handle);
      } catch (ex) {
        throwSystem(method, ex);
      }
    },
    create: function create(stream) {
      var method = "Zip.create";

      if (stream !== undefined) {
        checkStream(stream, method, "stream");
      } else {
        stream = File.createTemp();
      }

      try {
        var service = getCompressionService();
        return wrapZipArchive(service.OpenZipArchive(stream._handle), stream);
      } catch (ex) {
        throwSystem(method, ex);
      }
    },
    open: function open(stream) {
      var method = "Zip.open";
      checkStream(stream, method, "stream");

      try {
        var service = getCompressionService();
        return wrapZipArchive(service.OpenZipArchive(stream._handle), stream);
      } catch (ex) {
        throwSystem(method, ex);
      }
    },
    compress: function compress(path, output, callback) {
      var method = "Zip.compress";
      checkString(path, method, "path");

      if (arguments.length > 2) {
        checkStream(output, method, "output");
      } else {
        callback = output;
        output = File.createTemp();
      }

      checkFunction(callback, method, "callback");

      try {
        getCompressionService().Compress(path, output._handle, function (handle, error) {
          completeAsync(method, callback, error, output);
        }, null);
      } catch (ex) {
        throwSystem(method, ex);
      }
    }
  };

  var parseRdn = function () {
    function isWhiteSpace(ch) {
      return ch === ' ' || ch === '\r' || ch === '\t' || ch === '\n';
    }

    function trim(str) {
      return str.trim ? str.trim() : str.replace(/^\s+|\s+$/g, "");
    }

    function addProperty(object, key, value) {
      if (key in object) {
        var items = object[key];

        if (!(items instanceof Array)) {
          object[key] = items = [items];
        }

        items.push(value);
      } else {
        object[key] = value;
      }
    }

    return function (rdn) {
      if (!rdn || !rdn.length) {
        return {};
      }

      var state = 0,
          key = "",
          obj = {},
          startIndex = 0,
          isQuoted = false,
          ch;

      for (var i = 0, len = rdn.length; i < len; i++) {
        ch = rdn.charAt(i);

        switch (state) {
          case 0:
            // initial
            if (!isWhiteSpace(rdn.charAt(i))) {
              state = 1; // keyStart

              startIndex = i;

              if (ch === '"') {
                isQuoted = true;
                startIndex++;
              }
            }

            break;

          case 1:
            // keyStart
            if (ch === '=') {
              key = trim(rdn.substr(startIndex, i - startIndex - (isQuoted ? 1 : 0)));
              state = 2; // keyEnd

              isQuoted = false;
            }

            break;

          case 2:
            // keyEnd
            if (!isWhiteSpace(rdn.charAt(i))) {
              if (ch === ',' || ch === ';') {
                state = 0; // initial

                addProperty(obj, key, "");
                key = "";
              } else {
                state = 3; // valueStart

                startIndex = i;

                if (ch === '"') {
                  isQuoted = true;
                  startIndex++;
                }
              }
            }

            break;

          case 3:
            if (ch === '"') {
              if (!isQuoted || rdn.charAt(i + 1) !== '"') {
                var value = rdn.substr(startIndex, i - startIndex);

                if (isQuoted) {
                  value = value.replace(/""/g, '"');
                }

                addProperty(obj, key, value);
                key = "";
                isQuoted = false;
              } else {
                i++;
              }
            } else if ((ch === ',' || ch === ';') && !isQuoted) {
              state = 0; // initial

              if (key) {
                addProperty(obj, key, trim(rdn.substr(startIndex, i - startIndex)));
                key = "";
              }
            }

            break;

          default:
            break;
        }
      }

      if (key) {
        addProperty(obj, key, trim(rdn.substr(startIndex, i - startIndex)));
      }

      return obj;
    };
  }();

  function CertificateDistinguishedName(rdnString) {
    var attrs = null;

    this.toString = function () {
      return rdnString || "";
    };

    this.parse = function () {
      if (attrs === null) {
        attrs = parseRdn(rdnString);
      }

      return attrs;
    };

    this.getValue = function (key) {
      if (attrs === null) {
        attrs = parseRdn(rdnString);
      }

      var value = attrs[key];

      if (value instanceof Array) {
        return value.join(';');
      }

      return value;
    };
  } // exports for tests


  toolbox.CertificateDistinguishedName = CertificateDistinguishedName;

  function Certificate(handle) {
    if (handle === null || handle === undefined) {
      throw "Required certificate handle";
    }

    this._handle = handle;
  }

  function isCertificate(value) {
    return value instanceof Certificate;
  }

  function wrapCertificate(handle) {
    return new Certificate(handle);
  }

  function checkCertificate(value, method, name) {
    if (!isCertificate(value)) {
      throwArgument(method, name || "certificate");
    }
  }

  function getCertificateQueryString(query, method) {
    if (query === undefined) {
      return "";
    }

    var type = typeof query;

    if (type === "string") {
      return query;
    } else if (type === "object") {
      return json.stringify(query);
    } else {
      throwArgument(method, "query");
    }
  }

  function bindCertificate(certificate, method) {
    try {
      var query = getCertificateQueryString({
        hash: certificate.getHash().toHexString()
      }, method);
      var certs = getCryptoService().GetCertificates(query);

      if (certs.Count > 0) {
        return wrapCertificate(certs.Item(0));
      }
    } catch (ex) {}

    return certificate;
  }

  function getCertificateCollection(certificates, method) {
    if (certificates === null || certificates === undefined) {
      throwArgument(method, "certificates");
    }

    var collection = CertificateCollection.create(certificates);

    if (collection === undefined) {
      throwArgument(method, "certificates");
    }

    return collection;
  }

  Certificate.prototype = {
    constructor: Certificate,
    getName: function getName(forIssuer) {
      var method = "Certificate.getName";

      if (forIssuer === undefined) {
        forIssuer = false;
      } else if (typeof forIssuer !== "boolean") {
        throwArgument(method, "forIssuer");
      }

      try {
        return forIssuer ? this._handle.IssuerName : this._handle.CommonName;
      } catch (ex) {
        throwSystem(method, ex);
      }
    },
    getIssuer: function getIssuer() {
      try {
        return new CertificateDistinguishedName(this._handle.Issuer);
      } catch (ex) {
        throwSystem("Certificate.getIssuer", ex);
      }
    },
    getSubject: function getSubject() {
      try {
        return new CertificateDistinguishedName(this._handle.Subject);
      } catch (ex) {
        throwSystem("Certificate.getSubject", ex);
      }
    },
    getValidFrom: function getValidFrom() {
      try {
        return getProxy().getDate(this._handle.ValidFrom);
      } catch (ex) {
        throwSystem("Certificate.getValidFrom", ex);
      }
    },
    getValidTo: function getValidTo() {
      try {
        return getProxy().getDate(this._handle.ValidTo);
      } catch (ex) {
        throwSystem("Certificate.getValidTo", ex);
      }
    },
    getPublicKeyLength: function getPublicKeyLength() {
      try {
        return this._handle.PublicKeyLength;
      } catch (ex) {
        throwSystem("Certificate.getPublicKeyLength", ex);
      }
    },
    getPublicKeyAlgorithm: function getPublicKeyAlgorithm() {
      try {
        return this._handle.PublicKeyAlgorithm;
      } catch (ex) {
        throwSystem("Certificate.getPublicKeyAlgorithm", ex);
      }
    },
    hasPrivateKey: function hasPrivateKey() {
      try {
        return this._handle.HasPrivateKey;
      } catch (ex) {
        throwSystem("Certificate.hasPrivateKey", ex);
      }
    },
    getExtensions: function getExtensions() {
      var extensions;

      try {
        extensions = this._handle.GetExtensions();
      } catch (ex) {
        throwSystem("Certificate.getExtensions", ex);
      }

      return json.parse(extensions);
    },
    getHash: function getHash() {
      try {
        return wrapBinary(this._handle.Hash);
      } catch (ex) {
        throwSystem("Certificate.getHash", ex);
      }
    },
    getContent: function getContent() {
      try {
        return wrapBinary(this._handle.Content);
      } catch (ex) {
        throwSystem("Certificate.getContent", ex);
      }
    },
    getSerialNumber: function getSerialNumber() {
      try {
        return wrapBinary(this._handle.SerialNumber);
      } catch (ex) {
        throwSystem("Certificate.getSerialNumber", ex);
      }
    },
    verify: function verify(flags) {
      var method = "Certificate.verify";

      if (flags !== undefined) {
        checkNumber(flags, method, "flags");
      } else {
        flags = 0x40000000;
      }

      try {
        var cryptoService = getCryptoService();
        return cryptoService.VerifyCertificate(this._handle, flags);
      } catch (ex) {
        throwSystem(method, ex);
      }
    },
    verifyAsync: function verifyAsync(flags, callback) {
      var method = "Certificate.verifyAsync";

      if (arguments.length > 1) {
        checkNumber(flags, method, "flags");
      } else {
        callback = flags;
        flags = 0x40000000;
      }

      checkFunction(callback, method, "callback");

      try {
        var cryptoService = getCryptoService();
        cryptoService.VerifyCertificateAsync(this._handle, flags, function (status, error) {
          completeAsync(method, callback, error, status);
        });
      } catch (ex) {
        throwSystem(method, ex);
      }
    },
    getArchived: function getArchived() {
      try {
        return this._handle.Archived;
      } catch (ex) {
        throwSystem("Certificate.getArchived", ex);
      }
    },
    setArchived: function setArchived(archived) {
      var method = "Certificate.setArchived";

      try {
        if (archived === undefined) {
          archived = true;
        } else if (typeof archived !== "boolean") {
          throwArgument(method, "archived");
        }

        this._handle.Archived = archived;
      } catch (ex) {
        throwSystem(method, ex);
      }
    },
    getDescription: function getDescription() {
      try {
        return json.parse(this._handle.Description);
      } catch (ex) {
        throwSystem("Certificate.getDescription", ex);
      }
    },
    getVersion: function getVersion() {
      try {
        return this._handle.Version;
      } catch (ex) {
        throwSystem("Certificate.getVersion", ex);
      }
    },
    getRdnValue: function getRdnValue(oid, forIssuer) {
      var method = "Certificate.getRdnValue";

      if (forIssuer === undefined) {
        forIssuer = false;
      } else if (typeof forIssuer !== "boolean") {
        throwArgument(method, "forIssuer");
      }

      checkString(oid, method, "oid");

      try {
        return this._handle.GetRdnValue(oid, forIssuer);
      } catch (ex) {
        throwSystem(method, ex);
      }
    },
    getContainerInfo: function getContainerInfo() {
      try {
        return json.parse(this._handle.GetContainerInfo());
      } catch (ex) {
        throwSystem("Certificate.getContainerInfo", ex);
      }
    },
    getOnlineCertificateStatusProtocol: function getOnlineCertificateStatusProtocol() {
      try {
        return this._handle.GetOnlineCertificateStatusProtocol();
      } catch (ex) {
        throwSystem("Certificate.getOnlineCertificateStatusProtocol", ex);
      }
    },
    display: function display() {
      try {
        this._handle.Display();
      } catch (ex) {
        throwSystem("Certificate.display", ex);
      }
    },
    uninstall: function uninstall() {
      try {
        this._handle.Uninstall();
      } catch (ex) {
        throwSystem("Certificate.uninstall", ex);
      }
    }
  };
  toolbox.Certificate = Certificate;
  var CertificateCollection = Certificate.Collection = {
    create: function create(items) {
      var collection = createObject("CertificateCollection");

      if (items === undefined || items === null) {
        return collection;
      }

      if (isCertificate(items)) {
        collection.Add(items._handle);
      } else if (items instanceof Array) {
        for (var i = 0, len = items.length; i < len; i++) {
          var item = items[i];

          if (!isCertificate(item)) {
            return undefined;
          }

          collection.Add(item._handle);
        }
      } else {
        return undefined;
      }

      return collection;
    },
    toArray: function toArray(handle) {
      if (!handle) {
        throw "invalid collection handle";
      }

      var items = [];

      for (var i = 0, len = handle.Count; i < len; i++) {
        var certificateHandle = handle.Item(i);
        items.push(new Certificate(certificateHandle));
      }

      return items;
    }
  };

  function CryptoProvider(handle) {
    this._getHandle = function () {
      return handle || getCryptoService();
    };
  }

  function wrapCryptoProvider(handle) {
    return new CryptoProvider(handle);
  }

  CryptoProvider.prototype = {
    constructor: CryptoProvider,
    getName: function getName() {
      try {
        return this._getHandle().Name;
      } catch (ex) {
        throwSystem("CryptoProvider.getName", ex);
      }
    },
    getType: function getType() {
      try {
        return this._getHandle().Type;
      } catch (ex) {
        throwSystem("CryptoProvider.getType", ex);
      }
    },
    encrypt: function encrypt(binary, certificates) {
      var method = "CryptoProvider.encrypt";
      checkBinary(binary, method);
      var certsHandle = getCertificateCollection(certificates, method);

      try {
        var handle = this._getHandle().Encrypt(binary._handle, certsHandle);

        return wrapBinary(handle);
      } catch (ex) {
        throwSystem(method, ex);
      }
    },
    encryptAsync: function encryptAsync(binary, certificates, callback) {
      var method = "CryptoProvider.encryptAsync";
      checkBinary(binary, method);
      checkFunction(callback, method, "callback");
      var certsHandle = getCertificateCollection(certificates, method);

      try {
        this._getHandle().EncryptAsync(binary._handle, certsHandle, function (handle, error) {
          var wrappedBinary = error ? undefined : wrapBinary(handle);
          completeAsync(method, callback, error, wrappedBinary);
        });
      } catch (ex) {
        throwSystem(method, ex);
      }
    },
    decrypt: function decrypt(binary) {
      var method = "CryptoProvider.decrypt";
      checkBinary(binary, method);

      try {
        var handle = this._getHandle().Decrypt(binary._handle);

        return wrapBinary(handle);
      } catch (ex) {
        throwSystem(method, ex);
      }
    },
    decryptAsync: function decryptAsync(binary, callback) {
      var method = "CryptoProvider.decryptAsync";
      checkBinary(binary, method);
      checkFunction(callback, method, "callback");

      try {
        this._getHandle().DecryptAsync(binary._handle, function (handle, error) {
          var wrappedBinary = error ? undefined : wrapBinary(handle);
          completeAsync(method, callback, error, wrappedBinary);
        });
      } catch (ex) {
        throwSystem(method, ex);
      }
    },
    rawSign: function rawSign(binary, certificate) {
      var method = "CryptoProvider.rawSign";
      checkBinary(binary, method);
      checkCertificate(certificate, method);

      try {
        certificate = bindCertificate(certificate, method);

        var handle = this._getHandle().RawSign(binary._handle, certificate._handle);

        return wrapBinary(handle);
      } catch (ex) {
        throwSystem(method, ex);
      }
    },
    sign: function sign(binary, certificate, addCertChain) {
      var method = "CryptoProvider.sign";
      checkBinary(binary, method);
      checkCertificate(certificate, method);

      if (addCertChain !== undefined) {
        checkBoolean(addCertChain, method, "addCertChain");
      } else {
        addCertChain = false;
      }

      try {
        certificate = bindCertificate(certificate, method);
        var handle;

        if (addCertChain) {
          handle = this._getHandle().Sign(binary._handle, certificate._handle, addCertChain);
        } else {
          handle = this._getHandle().Sign(binary._handle, certificate._handle);
        }

        return wrapBinary(handle);
      } catch (ex) {
        throwSystem(method, ex);
      }
    },
    attachedSign: function attachedSign(binary, certificate, addCertChain) {
      var method = "CryptoProvider.attachedSign";
      checkBinary(binary, method);
      checkCertificate(certificate, method);

      if (addCertChain !== undefined) {
        checkBoolean(addCertChain, method, "addCertChain");
      } else {
        addCertChain = false;
      }

      try {
        certificate = bindCertificate(certificate, method);
        var handle;

        if (addCertChain) {
          handle = this._getHandle().AttachedSign(binary._handle, certificate._handle, addCertChain);
        } else {
          handle = this._getHandle().AttachedSign(binary._handle, certificate._handle);
        }

        return wrapBinary(handle);
      } catch (ex) {
        throwSystem(method, ex);
      }
    },
    signAsync: function signAsync(binary, certificate, addCertChain, callback) {
      var method = "CryptoProvider.signAsync";
      checkBinary(binary, method);
      checkCertificate(certificate, method);

      if (typeof addCertChain === "function") {
        callback = addCertChain;
        addCertChain = false;
      } else {
        checkBoolean(addCertChain, method, "addCertChain");
        checkFunction(callback, method, "callback");
      }

      try {
        certificate = bindCertificate(certificate, method);

        var wrappedCallback = function wrappedCallback(handle, error) {
          var wrappedBinary = error ? undefined : wrapBinary(handle);
          completeAsync(method, callback, error, wrappedBinary);
        };

        if (addCertChain) {
          this._getHandle().SignAsync(binary._handle, certificate._handle, wrappedCallback, addCertChain);
        } else {
          this._getHandle().SignAsync(binary._handle, certificate._handle, wrappedCallback);
        }
      } catch (ex) {
        throwSystem(method, ex);
      }
    },
    attachedSignAsync: function attachedSignAsync(binary, certificate, addCertChain, callback) {
      var method = "CryptoProvider.attachedSignAsync";
      checkBinary(binary, method);
      checkCertificate(certificate, method);

      if (typeof addCertChain === "function") {
        callback = addCertChain;
        addCertChain = false;
      } else {
        checkBoolean(addCertChain, method, "addCertChain");
        checkFunction(callback, method, "callback");
      }

      try {
        certificate = bindCertificate(certificate, method);

        var wrappedCallback = function wrappedCallback(handle, error) {
          var wrappedBinary = error ? undefined : wrapBinary(handle);
          completeAsync(method, callback, error, wrappedBinary);
        };

        if (addCertChain) {
          this._getHandle().AttachedSignAsync(binary._handle, certificate._handle, wrappedCallback, addCertChain);
        } else {
          this._getHandle().AttachedSignAsync(binary._handle, certificate._handle, wrappedCallback);
        }
      } catch (ex) {
        throwSystem(method, ex);
      }
    },
    addSignerToSignature: function addSignerToSignature(signature, data, certificate) {
      var method = "CryptoProvider.addSignerToSignature";
      checkBinary(signature, method);

      if (!isBinary(data)) {
        certificate = data;
        data = new Binary();
      }

      checkCertificate(certificate, method);

      try {
        certificate = bindCertificate(certificate, method)._handle;

        var handle = this._getHandle().AddSignerToSignature(signature._handle, data._handle, certificate);

        return wrapBinary(handle);
      } catch (ex) {
        throwSystem(method, ex);
      }
    },
    verifySignature: function verifySignature(binary, signature, certificates) {
      var certsHandle = null,
          method = "CryptoProvider.verifySignature";
      checkBinary(binary, method);
      checkBinary(signature, method, "signature");

      if (certificates) {
        certsHandle = getCertificateCollection(certificates, method);
      }

      try {
        var handle = this._getHandle().VerifySignature(binary._handle, signature._handle, certsHandle);

        return CertificateCollection.toArray(handle);
      } catch (ex) {
        throwSystem(method, ex);
      }
    },
    verifySignatureAsync: function verifySignatureAsync(binary, signature, certificates, callback) {
      var certsHandle = null,
          method = "CryptoProvider.verifySignatureAsync";
      checkBinary(binary, method);
      checkBinary(signature, method, "signature");

      if (typeof certificates === "function") {
        callback = certificates;
      } else {
        if (certificates) {
          certsHandle = getCertificateCollection(certificates, method);
        }

        checkFunction(callback, method, "callback");
      }

      try {
        this._getHandle().VerifySignatureAsync(binary._handle, signature._handle, certsHandle, function (handle, error) {
          var certs = error ? undefined : CertificateCollection.toArray(handle);
          completeAsync(method, callback, error, certs);
        });
      } catch (ex) {
        throwSystem(method, ex);
      }
    },
    verifyAttachedSignature: function verifyAttachedSignature(signature, certificates) {
      var certsHandle = null,
          method = "CryptoProvider.verifyAttachedSignature";
      checkBinary(signature, method, "signature");

      if (certificates) {
        certsHandle = getCertificateCollection(certificates, method);
      }

      try {
        var handle = this._getHandle().VerifyAttachedSignature(signature._handle, certsHandle);

        return CertificateCollection.toArray(handle);
      } catch (ex) {
        throwSystem(method, ex);
      }
    },
    verifyAttachedSignatureAsync: function verifyAttachedSignatureAsync(signature, certificates, callback) {
      var certsHandle = null,
          method = "CryptoProvider.verifyAttachedSignatureAsync";
      checkBinary(signature, method, "signature");

      if (typeof certificates === "function") {
        callback = certificates;
      } else {
        if (certificates) {
          certsHandle = getCertificateCollection(certificates, method);
        }

        checkFunction(callback, method, "callback");
      }

      try {
        this._getHandle().VerifyAttachedSignatureAsync(signature._handle, certsHandle, function (handle, error) {
          var certs = error ? undefined : CertificateCollection.toArray(handle);
          completeAsync(method, callback, error, certs);
        });
      } catch (ex) {
        throwSystem(method, ex);
      }
    },
    installCertificateResponse: function installCertificateResponse(response, containerPath, storeName) {
      var method = "CryptoProvider.installCertificateResponse";
      checkString(response, method, "response");

      if (arguments.length > 2) {
        checkString(containerPath, method, "containerPath");
      } else {
        storeName = containerPath;
      }

      checkString(storeName, method, "storeName");

      try {
        var handle;

        if (arguments.length > 2) {
          handle = this._getHandle().InstallCertificateResponseEx(response, containerPath, storeName);
        } else {
          handle = this._getHandle().InstallCertificateResponse(response, storeName);
        }

        return wrapCertificate(handle);
      } catch (ex) {
        throwSystem(method, ex);
      }
    },
    createCertificationRequest: function createCertificationRequest(containerName, keySpec, distinguishedName, extensions, exportable, silent) {
      var method = "CryptoProvider.createCertificationRequest";
      checkString(containerName, method, "containerName");
      checkNumber(keySpec, method, "keySpec");
      checkBinary(distinguishedName, method, "distinguishedName");
      checkBinary(extensions, method, "extensions");

      if (exportable !== undefined) {
        if (typeof exportable !== "boolean") {
          throwArgument(method, "exportable");
        }
      } else {
        exportable = true;
      }

      if (silent !== undefined) {
        if (typeof silent !== "boolean") {
          throwArgument(method, "silent");
        }
      } else {
        silent = false;
      }

      try {
        var handle = this._getHandle().CreateCertificationRequest(containerName, keySpec, distinguishedName._handle, extensions._handle, exportable, silent);

        return wrapBinary(handle);
      } catch (ex) {
        throwSystem(method, ex);
      }
    },
    createCertificationRequestEx: function createCertificationRequestEx(containerName, keySpec, distinguishedName, extensions, enrollmentParameters, exportable, silent) {
      var method = "CryptoProvider.createCertificationRequestEx";
      checkString(containerName, method, "containerName");
      checkNumber(keySpec, method, "keySpec");
      checkBinary(distinguishedName, method, "distinguishedName");
      checkBinary(extensions, method, "extensions");

      if (!isBinary(enrollmentParameters)) {
        silent = exportable;
        exportable = enrollmentParameters;
        enrollmentParameters = null;
      }

      if (exportable !== undefined) {
        if (typeof exportable !== "boolean") {
          throwArgument(method, "exportable");
        }
      } else {
        exportable = true;
      }

      if (silent !== undefined) {
        if (typeof silent !== "boolean") {
          throwArgument(method, "silent");
        }
      } else {
        silent = false;
      }

      try {
        var result;

        if (enrollmentParameters === null) {
          result = this._getHandle().CreateCertificationRequestEx(containerName, keySpec, distinguishedName._handle, extensions._handle, exportable, silent);
        } else {
          result = this._getHandle().CreateCertificationRequestExV2(containerName, keySpec, distinguishedName._handle, extensions._handle, enrollmentParameters._handle, exportable, silent);
        }

        return json.parse(result);
      } catch (ex) {
        throwSystem(method, ex);
      }
    },
    createCertificationRequestGOST: function createCertificationRequestGOST(slot, pin, distinguishedName, extensions, enrollmentParameters) {
      var method = "CryptoProvider.createCertificationRequestGOST";
      checkString(slot, method, "slot");
      checkString(pin, method, "pin");
      checkBinary(distinguishedName, method, "distinguishedName");
      checkBinary(extensions, method, "extensions");

      if (enrollmentParameters !== undefined) {
        checkBinary(enrollmentParameters, method, "enrollmentParameters");
      }

      try {
        var result;

        if (enrollmentParameters !== undefined) {
          result = this._getHandle().CreateCertificationRequestGOSTV2(slot, pin, distinguishedName._handle, extensions._handle, enrollmentParameters._handle);
        } else {
          result = this._getHandle().CreateCertificationRequestGOST(slot, pin, distinguishedName._handle, extensions._handle);
        }

        return json.parse(result);
      } catch (ex) {
        throwSystem(method, ex);
      }
    },
    installCertificateResponseGOST: function installCertificateResponseGOST(response, containerPath, pin) {
      var method = "CryptoProvider.installCertificateResponseGOST";
      checkString(response, method, "response");
      checkString(containerPath, method, "containerPath");
      checkString(pin, method, "pin");

      try {
        this._getHandle().InstallCertificateResponseGOST(response, containerPath, pin);
      } catch (ex) {
        throwSystem(method, ex);
      }
    },
    copyKeyContainer: function copyKeyContainer(certificate, destination) {
      var method = "CryptoProvider.copyKeyContainer";
      checkCertificate(certificate, method, "certificate");
      checkString(destination, method, "destination");

      try {
        certificate = bindCertificate(certificate, method);

        this._getHandle().CopyKeyContainer(certificate._handle, destination);
      } catch (ex) {
        throwSystem(method, ex);
      }
    },
    getTokenCerts: function getTokenCerts(tokenId) {
      var method = "CryptoProvider.getTokenCerts";
      checkString(tokenId, method, "tokenId");

      try {
        return json.parse(this._getHandle().GetTokenContainers(tokenId));
      } catch (ex) {
        throwSystem(method, ex);
      }
    }
  };

  function getCryptoService() {
    return getSingletonObject("CryptoService");
  }

  toolbox.Crypto = new CryptoProvider();
  extend(toolbox.Crypto, {
    getName: undefined,
    getType: undefined,
    getCertificates: function getCertificates(query) {
      var method = "Crypto.getCertificates";
      query = getCertificateQueryString(query, method);

      try {
        var handle = getCryptoService().GetCertificates(query);
        return CertificateCollection.toArray(handle);
      } catch (ex) {
        throwSystem(method, ex);
      }
    },
    getPersonalCertificates: function getPersonalCertificates() {
      return toolbox.Crypto.getCertificates({
        storeName: "My",
        hasPrivateKey: true
      });
    },
    getCertificatesAsync: function getCertificatesAsync(query, callback) {
      var method = "Crypto.getCertificatesAsync";
      checkFunction(callback, method, "callback");
      query = getCertificateQueryString(query, method);

      try {
        getCryptoService().GetCertificatesAsync(query, function (handle, error) {
          var certs = error ? undefined : CertificateCollection.toArray(handle);
          completeAsync(method, callback, error, certs);
        });
      } catch (ex) {
        throwSystem(method, ex);
      }
    },
    findCertificate: function findCertificate(query) {
      var method = "Crypto.findCertificate";
      query = getCertificateQueryString(query, method);

      try {
        return wrapCertificate(getCryptoService().FindCertificate(query));
      } catch (ex) {
        throwSystem(method, ex);
      }
    },
    findCertificateAsync: function findCertificateAsync(query, callback) {
      var method = "Crypto.findCertificateAsync";
      checkFunction(callback, method, "callback");
      query = getCertificateQueryString(query, method);

      try {
        getCryptoService().FindCertificateAsync(query, function (handle, error) {
          var cert = error ? undefined : wrapCertificate(handle);
          completeAsync(method, callback, error, cert);
        });
      } catch (ex) {
        throwSystem(method, ex);
      }
    },
    extractCertificatesFromSignature: function extractCertificatesFromSignature(signature) {
      var method = "Crypto.extractCertificatesFromSignature";
      checkBinary(signature, method, "signature");

      try {
        var handle = getCryptoService().ExtractCertificatesFromSignature(signature._handle);
        return CertificateCollection.toArray(handle);
      } catch (ex) {
        throwSystem(method, ex);
      }
    },
    extractContentFromSignature: function extractContentFromSignature(signature) {
      var method = "Crypto.extractContentFromSignature";
      checkBinary(signature, method, "signature");

      try {
        var handle = getCryptoService().ExtractContentFromSignature(signature._handle);
        return wrapBinary(handle);
      } catch (ex) {
        throwSystem(method, ex);
      }
    },
    getCertificatesFromSignature: function getCertificatesFromSignature(signature) {
      var method = "Crypto.getCertificatesFromSignature";
      checkBinary(signature, method, "signature");

      try {
        var handle = getCryptoService().GetCertificatesFromSignature(signature._handle);
        return CertificateCollection.toArray(handle);
      } catch (ex) {
        throwSystem(method, ex);
      }
    },
    getContentFromSignature: function getContentFromSignature(signature) {
      var method = "Crypto.getContentFromSignature";
      checkBinary(signature, method, "signature");

      try {
        var handle = getCryptoService().GetContentFromSignature(signature._handle);
        return wrapBinary(handle);
      } catch (ex) {
        throwSystem(method, ex);
      }
    },
    createCertificateFromContent: function createCertificateFromContent(content, bindPrivateKey) {
      var method = "Crypto.createCertificateFromContent";
      checkBinary(content, method, "content");

      try {
        var cert = wrapCertificate(getCryptoService().CreateCertificateFromContent(content._handle));

        if (!!bindPrivateKey) {
          var query = getCertificateQueryString({
            hash: cert.getHash().toHexString()
          }, method);
          return wrapCertificate(getCryptoService().FindCertificate(query));
        }

        return cert;
      } catch (ex) {
        throwSystem(method, ex);
      }
    },
    generateCertificateRenewalRequest: function generateCertificateRenewalRequest(isPkcs7, certificate) {
      var method = "Crypto.generateCertificateRenewalRequest";

      if (typeof isPkcs7 !== "boolean") {
        throwArgument(method, "isPkcs7");
      }

      checkCertificate(certificate, method);

      try {
        return getCryptoService().GenerateCertificateRenewalRequest(isPkcs7, certificate._handle);
      } catch (ex) {
        throwSystem(method, ex);
      }
    },
    getTokenDriverVersion: function getTokenDriverVersion(guid) {
      try {
        return getCryptoService().GetTokenDriverVersion(guid);
      } catch (ex) {
        throwSystem("Crypto.getTokenDriverVersion", ex);
      }
    },
    getProvidersInfos: function getProvidersInfos() {
      try {
        return json.parse(getCryptoService().GetCryptoProvidersInfo());
      } catch (ex) {
        throwSystem("Crypto.getProvidersInfos", ex);
      }
    },
    getTokensInfos: function getTokensInfos() {
      try {
        return json.parse(getCryptoService().GetTokensInfo());
      } catch (ex) {
        throwSystem("Crypto.getTokensInfos", ex);
      }
    },
    getTokensInfosAsync: function getTokensInfosAsync(callback) {
      var method = "Crypto.getTokensInfosAsync";
      checkFunction(callback, method, "callback");

      try {
        getCryptoService().GetTokensInfoAsync(function (result, error) {
          completeAsync(method, callback, error, error ? undefined : json.parse(result));
        });
      } catch (ex) {
        throwSystem(method, ex);
      }
    },
    getCryptoProLicense: function getCryptoProLicense(guid) {
      var method = "Crypto.getCryptoProLicense";

      if (guid !== undefined) {
        checkString(guid, method, "guid");
      } else {
        guid = "";
      }

      try {
        return getCryptoService().GetCryptoProLicense(guid);
      } catch (ex) {
        throwSystem(method, ex);
      }
    },
    getDefaultCryptoProvider: function getDefaultCryptoProvider() {
      try {
        var key = "Default.Crypto.Provider";
        var provider = objectCache[key];

        if (provider === undefined) {
          provider = getCryptoService().GetDefaultCryptoProvider();
          objectCache[key] = provider;
        }

        return wrapCryptoProvider(provider);
      } catch (ex) {
        throwSystem("Crypto.getDefaultCryptoProvider", ex);
      }
    },
    getCryptoProvider: function getCryptoProvider(name, type) {
      var method = "Crypto.getCryptoProvider";
      checkString(name, method, "name");
      checkNumber(type, method, "type");

      try {
        var key = type.toString();
        var provider = objectCache[key];

        if (provider === undefined) {
          provider = getCryptoService().GetCryptoProvider(name, type);
          objectCache[key] = provider;
        }

        return wrapCryptoProvider(provider);
      } catch (ex) {
        throwSystem(method, ex);
      }
    }
  });

  function File(handle) {
    if (handle === null || handle === undefined) {
      throw "Required file handle";
    }

    this._handle = handle;
  }

  function wrapFile(handle) {
    return new File(handle);
  }

  function isFile(value) {
    return value instanceof File;
  }

  implement(File, Stream, {
    getPath: function getPath() {
      try {
        return this._handle.Path;
      } catch (ex) {
        throwSystem("File.getPath", ex);
      }
    },
    getPosition: function getPosition() {
      try {
        return this._handle.Position;
      } catch (ex) {
        throwSystem("File.getPosition", ex);
      }
    },
    getSize: function getSize() {
      try {
        return this._handle.Size;
      } catch (ex) {
        throwSystem("File.getSize", ex);
      }
    },
    read: function read(count) {
      var method = "File.read";
      checkNumber(count, method, "count");

      try {
        return wrapBinary(this._handle.Read(count));
      } catch (ex) {
        throwSystem(method, ex);
      }
    },
    write: function write(binary, offset, count) {
      var method = "File.write";
      checkBinary(binary, method);

      if (offset === undefined || offset === null) {
        offset = 0;
      } else {
        checkNumber(offset, method, "offset");
      }

      if (count === undefined || count === null) {
        count = binary.getSize();
      } else {
        checkNumber(count, method, "count");
      }

      try {
        this._handle.Write(binary._handle, offset, count);
      } catch (ex) {
        throwSystem(method, ex);
      }
    },
    writeAsync: function writeAsync(binary, offset, count, callback) {
      var method = "File.writeAsync";
      checkBinary(binary, method);

      if (typeof offset === "function") {
        callback = offset;
        offset = 0;
        count = binary.getSize();
      } else {
        checkNumber(offset, method, "offset");
        checkNumber(count, method, "count");
        checkFunction(callback, method, "callback");
      }

      try {
        this._handle.WriteAsync(binary._handle, offset, count, function (handle, error) {
          completeAsync(method, callback, error);
        });
      } catch (ex) {
        throwSystem(method, ex);
      }
    },
    readAsync: function readAsync(count, callback) {
      var method = "File.readAsync";
      checkNumber(count, method, "count");
      checkFunction(callback, method, "callback");

      try {
        this._handle.ReadAsync(count, function (handle, error) {
          var wrappedBinary = error ? undefined : wrapBinary(handle);
          completeAsync(method, callback, error, wrappedBinary);
        });
      } catch (ex) {
        throwSystem(method, ex);
      }
    },
    writeToAsync: function writeToAsync(position, binary, offset, count, callback) {
      var method = "File.writeToAsync";
      checkNumber(position, method, "position");
      checkBinary(binary, method);

      if (typeof offset === "function") {
        callback = offset;
        offset = 0;
        count = binary.getSize();
      } else {
        checkNumber(offset, method, "offset");
        checkNumber(count, method, "count");
        checkFunction(callback, method, "callback");
      }

      try {
        this._handle.SeekAndWriteAsync(position, binary._handle, offset, count, function (handle, error) {
          completeAsync(method, callback, error);
        });
      } catch (ex) {
        throwSystem(method, ex);
      }
    },
    readFromAsync: function readFromAsync(position, count, callback) {
      var method = "File.readFromAsync";
      checkNumber(position, method, "position");
      checkNumber(count, method, "count");
      checkFunction(callback, method, "callback");

      try {
        this._handle.SeekAndReadAsync(position, count, function (handle, error) {
          var wrappedBinary = error ? undefined : wrapBinary(handle);
          completeAsync(method, callback, error, wrappedBinary);
        });
      } catch (ex) {
        throwSystem(method, ex);
      }
    },
    close: function close() {
      try {
        this._handle.Close();
      } catch (ex) {
        throwSystem("File.close", ex);
      }
    },
    resize: function resize(size) {
      var method = "File.resize";
      checkNumber(size, method, "size");

      try {
        this._handle.Resize(size);
      } catch (ex) {
        throwSystem(method, ex);
      }
    },
    flush: function flush() {
      try {
        this._handle.Flush();
      } catch (ex) {
        throwSystem("File.flush", ex);
      }
    },
    seek: function seek(position, location) {
      var method = "File.seek";
      checkNumber(position, method, "position");

      if (location === undefined || location === null) {
        location = 0;
      } else {
        checkNumber(location, method, "location");
      }

      try {
        return this._handle.Seek(position, location);
      } catch (ex) {
        throwSystem(method, ex);
      }
    }
  });
  toolbox.File = File;

  function getFileSystemService() {
    return getSingletonObject("FileSystemService");
  }

  var accessFlags = {
    Read: 1179785,
    Write: 1179926,
    ReadWrite: 1180063
  };
  var modeFlags = {
    CreateNew: 1,
    Create: 2,
    Open: 3,
    OpenOrCreate: 4,
    Truncate: 5
  };
  var shareFlags = {
    None: 0,
    Read: 1,
    Write: 2,
    ReadWrite: 3,
    Delete: 4
  };
  File.flags = {
    access: accessFlags,
    mode: modeFlags,
    share: shareFlags
  };

  File.getTempPath = function () {
    try {
      return getFileSystemService().GetTempFolder();
    } catch (ex) {
      throwSystem("File.getTempPath", ex);
    }
  };

  var defaultFlags = {
    access: accessFlags.ReadWrite,
    mode: modeFlags.Open,
    share: shareFlags.ReadWrite
  };

  File.open = function (path, flags) {
    var method = "File.open";
    checkString(path, method, "path");

    if (flags === undefined || flags === null) {
      flags = defaultFlags;
    }

    var access = flags.access;
    var mode = flags.mode;
    var share = flags.share;

    if (access === undefined || flags === null) {
      access = defaultFlags.access;
    } else {
      checkNumber(access, method, "access");
    }

    if (mode === undefined || flags === null) {
      mode = defaultFlags.mode;
    } else {
      checkNumber(mode, method, "mode");
    }

    if (share === undefined || flags === null) {
      share = defaultFlags.share;
    } else {
      checkNumber(share, method, "share");
    }

    try {
      var handle = getFileSystemService().OpenFile(path, access, mode, share);
      return wrapFile(handle);
    } catch (ex) {
      throwSystem(method, ex);
    }
  };

  File.openRead = function (path) {
    try {
      return File.open(path, {
        access: accessFlags.Read,
        mode: modeFlags.Open,
        share: shareFlags.ReadWrite
      });
    } catch (ex) {
      throwSystem("File.openRead", ex);
    }
  };

  File.openWrite = function (path) {
    try {
      return File.open(path, {
        access: accessFlags.Write,
        mode: modeFlags.Open,
        share: shareFlags.ReadWrite
      });
    } catch (ex) {
      throwSystem("File.openWrite", ex);
    }
  };

  File.create = function (path, overwrite) {
    try {
      return File.open(path, {
        access: accessFlags.ReadWrite,
        mode: !overwrite ? modeFlags.CreateNew : modeFlags.Create,
        share: shareFlags.ReadWrite
      });
    } catch (ex) {
      throwSystem("File.create", ex);
    }
  };

  File.createTemp = function () {
    try {
      return wrapFile(getFileSystemService().CreateTempFile());
    } catch (ex) {
      throwSystem("File.createTempFile", ex);
    }
  };

  File.getSize = function (path) {
    var method = "File.getSize";
    checkString(path, method, "path");

    try {
      return getFileSystemService().GetFileLength(path);
    } catch (ex) {
      throwSystem(method, ex);
    }
  };

  File.getCreateDate = function (path) {
    var method = "File.getCreateDate";
    checkString(path, method, "path");

    try {
      var date = getFileSystemService().GetCreateDate(path);
      return getProxy().getDate(date);
    } catch (ex) {
      throwSystem(method, ex);
    }
  };

  File.getLastAccess = function (path) {
    var method = "File.getLastAccess";
    checkString(path, method, "path");

    try {
      var date = getFileSystemService().GetLastAccess(path);
      return getProxy().getDate(date);
    } catch (ex) {
      throwSystem(method, ex);
    }
  };

  File.getLastModified = function (path) {
    var method = "File.getLastModified";
    checkString(path, method, "path");

    try {
      var date = getFileSystemService().GetLastModified(path);
      return getProxy().getDate(date);
    } catch (ex) {
      throwSystem(method, ex);
    }
  };

  File.exists = function (path) {
    var method = "File.exists";
    checkString(path, method, "path");

    try {
      return getFileSystemService().IsFileExists(path);
    } catch (ex) {
      throwSystem(method, ex);
    }
  };

  File.remove = function (path) {
    var method = "File.remove";
    checkString(path, method, "path");

    try {
      getFileSystemService().FileDelete(path);
    } catch (ex) {
      throwSystem(method, ex);
    }
  };

  File.moveAsync = function (oldPath, newPath, callback, token) {
    var method = "File.moveAsync";
    checkString(oldPath, method, "oldPath");
    checkString(newPath, method, "newPath");
    checkFunction(callback, method, "callback");

    try {
      getFileSystemService().FileMoveAsync(oldPath, newPath, function (handle, error) {
        completeAsync(method, callback, error);
      }, isDefined(token) ? token._handle : null);
    } catch (ex) {
      throwSystem(method, ex);
    }
  };

  File.copyAsync = function (oldPath, newPath, callback, token) {
    var method = "File.copyAsync";
    checkString(oldPath, method, "oldPath");
    checkString(newPath, method, "newPath");
    checkFunction(callback, method, "callback");

    try {
      getFileSystemService().FileCopyAsync(oldPath, newPath, function (handle, error) {
        completeAsync(method, callback, error);
      }, isDefined(token) ? token._handle : null);
    } catch (ex) {
      throwSystem(method, ex);
    }
  };

  File.createDir = function (path) {
    var method = "File.createDir";
    checkString(path, method, "path");

    try {
      getFileSystemService().CreateDir(path);
    } catch (ex) {
      throwSystem(method, ex);
    }
  };

  function getGuiService() {
    return getSingletonObject("GuiService");
  }

  function getGuiOptions(options, method) {
    if (options === undefined) {
      return "";
    }

    var type = typeof options;

    if (type === "string") {
      return options;
    } else if (type === "object") {
      return json.stringify(options);
    }

    throwArgument(method, "options");
  } // exports


  toolbox.Gui = {
    showOpenDialog: function showOpenDialog(options) {
      var method = "Gui.showOpenDialog";
      options = getGuiOptions(options, method);

      try {
        var result = getGuiService().ShowOpenDialog(options);
        return result && result.length ? result : undefined;
      } catch (ex) {
        throwSystem(method, ex);
      }
    },
    showSaveDialog: function showSaveDialog(fileName, options) {
      var method = "Gui.showSaveDialog";

      if (fileName === undefined) {
        fileName = "";
      } else {
        checkString(fileName, method, "fileName");
      }

      options = getGuiOptions(options, method);

      try {
        var result = getGuiService().ShowSaveDialog(fileName, options);
        return result && result.length ? result : undefined;
      } catch (ex) {
        throwSystem(method, ex);
      }
    },
    selectFolderDialog: function selectFolderDialog(options) {
      var method = "Gui.selectFolderDialog";
      options = getGuiOptions(options, method);

      try {
        var result = getGuiService().SelectFolderDialog(options);
        return result && result.length ? result : undefined;
      } catch (ex) {
        throwSystem(method, ex);
      }
    },
    showMultipleOpenDialog: function showMultipleOpenDialog(options) {
      var method = "Gui.showMultipleOpenDialog";
      options = getGuiOptions(options, method);
      var result,
          files = [];

      try {
        result = getGuiService().ShowMultipleOpenDialog(options);
      } catch (ex) {
        throwSystem(method, ex);
      }

      if (result && result.length) {
        var items = result.split('|'),
            firstFile = items[0];

        if (items.length > 1) {
          var dir = firstFile;

          for (var i = 1, len = items.length; i < len; i++) {
            files.push(dir + '\\' + items[i]);
          }
        } else {
          files.push(firstFile);
        }
      }

      return files;
    }
  };

  function CertificateStore()
  /*location, name, readOnly*/
  {
    this._handle = createObject("CertificateStore");

    if (arguments.length) {
      this.open.apply(this, arguments);
    }
  }

  function getCertStoreLocationCode(location, method) {
    checkString(location, method, "location");
    location = location.toLowerCase();

    if (location === "machine") {
      return 1;
    } else if (location === "user") {
      return 2;
    }

    throwArgument(method, "location");
  }

  CertificateStore.prototype = {
    constructor: CertificateStore,
    getName: function getName() {
      try {
        return this._handle.Name;
      } catch (ex) {
        throwSystem("CertificateStore.getName", ex);
      }
    },
    getLocation: function getLocation() {
      try {
        var code = this._handle.Location;
        return code === 1 ? "machine" : "user";
      } catch (ex) {
        throwSystem("CertificateStore.getLocation", ex);
      }
    },
    open: function open(location, name, readOnly) {
      var method = "CertificateStore.open",
          locationCode = getCertStoreLocationCode(location, method);
      checkString(name, method, "name");

      if (readOnly === undefined) {
        readOnly = true;
      } else if (typeof readOnly !== "boolean") {
        throwArgument(method, "readOnly");
      }

      try {
        this._handle.Open(locationCode, name, readOnly ? 2 : 1);
      } catch (ex) {
        throwSystem(method, ex);
      }
    },
    close: function close() {
      try {
        this._handle.Close();
      } catch (ex) {
        throwSystem("CertificateStore.close", ex);
      }
    },
    getItems: function getItems(query) {
      var method = "CertificateStore.getItems";
      query = getCertificateQueryString(query, method);

      try {
        var handle = this._handle.GetCertificates(query);

        return CertificateCollection.toArray(handle);
      } catch (ex) {
        throwSystem(method, ex);
      }
    },
    selectItem: function selectItem() {
      try {
        var handle = this._handle.SelectCertificate();

        return handle ? wrapCertificate(handle) : undefined;
      } catch (ex) {
        throwSystem("CertificateStore.selectItem", ex);
      }
    },
    install: function install(certificate) {
      var method = "CertificateStore.install";
      checkCertificate(certificate, method);

      try {
        var handle = this._handle.Install(certificate._handle);

        return handle ? wrapCertificate(handle) : undefined;
      } catch (ex) {
        throwSystem(method, ex);
      }
    }
  };
  toolbox.CertificateStore = CertificateStore;

  toolbox.Pipeline = function (stream, options) {
    checkStream(stream, "Pipeline");
    var stages = [],
        callbacks = {},
        step = -1,
        timer = null,
        token = null,
        finalized = false,
        close,
        that = this;
    options = extend({
      close: true
    }, options);

    function notify(nextStage) {
      var progress = callbacks.progress;

      if (progress) {
        try {
          progress(that.getCurrentStage(), token.progress());
        } catch (ex) {}
      }

      var changeStage = callbacks.changeStage;

      if (nextStage && changeStage) {
        changeStage(that.getCurrentStage());
      }
    }

    function complete(err, result) {
      notify();
      step = -1;

      if (timer) {
        global.clearInterval(timer);
        timer = null;
      }

      try {
        if (err) {
          if (callbacks.error) {
            callbacks.error(err);
          }
        } else {
          if (callbacks.success) {
            callbacks.success(result);
          }
        }

        if (callbacks.complete) {
          callbacks.complete(err, result);
        }
      } catch (ex) {
        raiseError(ex);
      }
    }

    function createOutput(stage, nextStage) {
      var output = null;

      if (nextStage && nextStage.input) {
        output = nextStage.input();
      } else if (!stage.isFinal) {
        if (stage.output) {
          output = stage.output();
        } else {
          if (!options.inMemory) {
            output = File.createTemp();
          } else {
            output = Binary.createStream();
          }
        }
      }

      return output;
    }

    function nextStage(input) {
      step++;
      notify(true);

      if (step === stages.length) {
        complete(null, input);
        return;
      }

      var stage = stages[step],
          output = null,
          callback;

      if (stage.output && stage.input && stage.output === stage.input && step > 0) {
        nextStage(input);
        return;
      }

      callback = function callback(err, result) {
        if (close) {
          closeStream(input);
        }

        close = true;

        if (err) {
          closeStream(output);
          complete(err, null);
        } else {
          try {
            if (isStream(output)) {
              output.seek(0);
            }
          } catch (ex) {
            complete(ex, null);
            return;
          }

          nextStage(result || output);
        }
      };

      try {
        output = createOutput(stage, stages[step + 1]);
        stage.process(input, output, callback, token, options);
      } catch (ex) {
        if (close) {
          closeStream(input);
        }

        closeStream(output);
        complete(ex, null);
      }
    }

    this.run = function (fn) {
      var method = "Pipeline.run";
      checkDefined(fn, method, "callbacks");

      if (typeof fn === "object") {
        callbacks = fn;
      } else {
        checkFunction(fn, method, "callbacks");
        callbacks = {
          complete: fn
        };
      }

      step = -1;
      token = new OperationToken();
      close = !!options.close;

      if (callbacks.progress) {
        timer = global.setInterval(notify, options.interval || 1000);
      }

      nextStage(stream);
      return this;
    };

    this.isRunning = function () {
      return step !== -1;
    };

    this.cancel = function () {
      if (step !== -1) {
        token.setCanceled();
      }

      return this;
    };

    this.getCurrentStage = function () {
      if (step === -1 || step === stages.length) {
        return "none";
      }

      return stages[step].name;
    };

    this.addStage = function (stage) {
      var method = "Pipeline.addStage";

      if (step !== -1) {
        throwError(method, "Pipeline is running.");
      }

      if (finalized) {
        throwError(method, "Pipeline is finalized");
      }

      if (!stage.process) {
        throwError(method, "Invalid pipeline stage");
      }

      stages.push(stage);
      finalized = stage.isFinal || false;
      return this;
    };
  };

  function createCopyProcess(method) {
    return function (input, output, callback) {
      try {
        input.copyToAsync(output, function (err, result) {
          if (!err) {
            output.seek(0);
          }

          callback(err, result);
        });
      } catch (ex) {
        throwSystem(method, ex);
      }
    };
  }

  function PipelineToFile(fileName) {
    var method = "pipeline.toFile";
    checkString(fileName, method, "fileName");

    this.input = this.output = function () {
      return File.create(fileName, true);
    };

    this.process = createCopyProcess(method);
  }

  function PipelineToBinaryStream() {
    var method = "pipeline.toBinaryStream";

    this.input = this.output = function () {
      return Binary.createStream();
    };

    this.process = createCopyProcess(method);
  }

  function PipelineCrc32() {
    var method = "Pipeline.crc32";
    this.isFinal = true;

    this.process = function (input, output, callback, token) {
      try {
        getBinaryService().GetCrc32StreamAsync(input._handle, function (crc32, error) {
          completeAsync(method, callback, error, crc32 >>> 0);
        }, token._handle);
      } catch (ex) {
        throwSystem(method, ex);
      }
    };
  }

  function PipelineMd5() {
    var method = "Pipeline.md5";
    this.isFinal = true;

    this.process = function (input, output, callback, token) {
      try {
        getBinaryService().GetMd5StreamAsync(input._handle, function (handle, error) {
          var result = error ? undefined : wrapBinary(handle);
          completeAsync(method, callback, error, result);
        }, token._handle);
      } catch (ex) {
        throwSystem(method, ex);
      }
    };
  }

  function PipelineSha256() {
    var method = "Pipeline.sha256";
    this.isFinal = true;

    this.process = function (input, output, callback, token) {
      try {
        getBinaryService().GetSHA256StreamAsync(input._handle, function (handle, error) {
          var result = error ? undefined : wrapBinary(handle);
          completeAsync(method, callback, error, result);
        }, token._handle);
      } catch (ex) {
        throwSystem(method, ex);
      }
    };
  }

  function PipelineGZip() {
    var method = "Pipeline.gzip";

    this.process = function (input, output, callback, token) {
      try {
        getCompressionService().GZipStreamAsync(input._handle, output._handle, function (handle, error) {
          completeAsync(method, callback, error);
        }, token._handle);
      } catch (ex) {
        throwSystem(method, ex);
      }
    };
  }

  function PipelineUnGZip() {
    var method = "Pipeline.ungzip";

    this.process = function (input, output, callback, token) {
      try {
        getCompressionService().GUnzipStreamAsync(input._handle, output._handle, function (handle, error) {
          completeAsync(method, callback, error);
        }, token._handle);
      } catch (ex) {
        throwSystem(method, ex);
      }
    };
  }

  function PipelineZip() {
    var method = "Pipeline.zip";

    this.process = function (input, output, callback, token) {
      try {
        getCompressionService().PKZipStreamAsync(input._handle, output._handle, function (handle, error) {
          completeAsync(method, callback, error);
        }, token._handle);
      } catch (ex) {
        throwSystem(method, ex);
      }
    };
  }

  function PipelineUnZip() {
    var method = "Pipeline.unzip";

    this.process = function (input, output, callback, token) {
      var fileIndex = 0;

      try {
        getCompressionService().PKUnzipNStreamAsync(input._handle, output._handle, function (handle, error) {
          completeAsync(method, callback, error);
        }, fileIndex, token._handle);
      } catch (ex) {
        throwSystem(method, ex);
      }
    };
  }

  function getPipelineCryptoHandle(options) {
    return (options.cryptoProvider || toolbox.Crypto)._getHandle();
  }

  function PipelineEncrypt(certificates) {
    var method = "Pipeline.encrypt";

    if (certificates === null || certificates === undefined) {
      throwArgument(method, "certificates");
    }

    this.process = function (input, output, callback, token, options) {
      var certsHandle = getCertificateCollection(certificates, method),
          crypto = getPipelineCryptoHandle(options);

      try {
        crypto.EncryptStreamAsync(input._handle, output._handle, certsHandle, function (handle, error) {
          completeAsync(method, callback, error);
        }, token._handle);
      } catch (ex) {
        throwSystem(method, ex);
      }
    };
  }

  function PipelineDecrypt() {
    var method = "Pipeline.decrypt";

    this.process = function (input, output, callback, token, options) {
      var crypto = getPipelineCryptoHandle(options);

      try {
        crypto.DecryptStreamAsync(input._handle, output._handle, function (handle, error) {
          completeAsync(method, callback, error);
        }, token._handle);
      } catch (ex) {
        throwSystem(method, ex);
      }
    };
  }

  function PipelineSign(certificate, addCertChain) {
    var method = "Pipeline.sign";
    checkCertificate(certificate, method);

    if (addCertChain !== undefined) {
      checkBoolean(addCertChain, method, "addCertChain");
    } else {
      addCertChain = false;
    }

    this.process = function (input, output, callback, token, options) {
      var crypto = getPipelineCryptoHandle(options),
          cert = bindCertificate(certificate, method)._handle;

      try {
        var wrapCallback = function wrapCallback(handle, error) {
          completeAsync(method, callback, error);
        };

        if (addCertChain) {
          crypto.SignStreamAsync(input._handle, output._handle, cert, false, wrapCallback, token._handle, addCertChain);
        } else {
          crypto.SignStreamAsync(input._handle, output._handle, cert, false, wrapCallback, token._handle);
        }
      } catch (ex) {
        throwSystem(method, ex);
      }
    };
  }

  function PipelineAttachedSign(certificate, addCertChain) {
    var method = "Pipeline.attachedSign";
    checkCertificate(certificate, method);

    if (addCertChain !== undefined) {
      checkBoolean(addCertChain, method, "addCertChain");
    } else {
      addCertChain = false;
    }

    this.process = function (input, output, callback, token, options) {
      var crypto = getPipelineCryptoHandle(options),
          cert = bindCertificate(certificate, method)._handle;

      try {
        var wrapCallback = function wrapCallback(handle, error) {
          completeAsync(method, callback, error);
        };

        if (addCertChain) {
          crypto.SignStreamAsync(input._handle, output._handle, cert, true, wrapCallback, token._handle, addCertChain);
        } else {
          crypto.SignStreamAsync(input._handle, output._handle, cert, true, wrapCallback, token._handle);
        }
      } catch (ex) {
        throwSystem(method, ex);
      }
    };
  }

  function PipelineVerifySignature(signature, certificates) {
    var method = "Pipeline.verify";
    checkBinary(signature, method, "signature");
    this.isFinal = true;

    this.process = function (input, output, callback, token, options) {
      var crypto = getPipelineCryptoHandle(options),
          certsHandle = null;

      if (certificates) {
        certsHandle = getCertificateCollection(certificates, method);
      }

      try {
        crypto.VerifyStreamSignatureAsync(signature._handle, input._handle, certsHandle, function (handle, error) {
          var certs = error ? undefined : CertificateCollection.toArray(handle);
          completeAsync(method, callback, error, certs);
        }, token._handle);
      } catch (ex) {
        throwSystem(method, ex);
      }
    };
  }

  function PipelineVerifyAttachedSignature(certificates) {
    var method = "Pipeline.verifyAttached";
    this.isFinal = true;

    this.process = function (input, output, callback, token, options) {
      var crypto = getPipelineCryptoHandle(options),
          certsHandle = null;

      if (certificates) {
        certsHandle = getCertificateCollection(certificates, method);
      }

      try {
        crypto.VerifyStreamAttachedSignatureAsync(input._handle, certsHandle, function (handle, error) {
          var certs = error ? undefined : CertificateCollection.toArray(handle);
          completeAsync(method, callback, error, certs);
        }, token._handle);
      } catch (ex) {
        throwSystem(method, ex);
      }
    };
  }

  (function () {
    var stageTypes = {
      toFile: PipelineToFile,
      toBinaryStream: PipelineToBinaryStream,
      crc32: PipelineCrc32,
      md5: PipelineMd5,
      sha256: PipelineSha256,
      gzip: PipelineGZip,
      ungzip: PipelineUnGZip,
      zip: PipelineZip,
      unzip: PipelineUnZip,
      encrypt: PipelineEncrypt,
      decrypt: PipelineDecrypt,
      sign: PipelineSign,
      attachedSign: PipelineAttachedSign,
      verifySignature: PipelineVerifySignature,
      verifyAttachedSignature: PipelineVerifyAttachedSignature
    };
    var slice = Array.prototype.slice;
    /* jshint loopfunc: true */

    for (var name in stageTypes) {
      var stageType = stageTypes[name];
      stageType.prototype.name = name;

      toolbox.Pipeline.prototype[name] = function (stageType) {
        return function () {
          var stage = construct(stageType, slice.call(arguments));
          return this.addStage(stage);
        };
      }(stageType);
    }
    /* jshint loopfunc: false */

  })();

  toolbox.isBinary = isBinary;
  toolbox.isCertificate = isCertificate;
  toolbox.isBinaryStream = isBinaryStream;
  toolbox.isFile = isFile;
  toolbox.isStream = isStream;
})(window);

module.exports = window.SkbKontur;